<ng-container *ngIf="user$ | async as _user">
  <!-- begin::Offcanvas Toolbar Quick Actions -->
  <div
    ktOffcanvas
    [options]="offcanvasOptions"
    id="kt_quick_user"
    class="offcanvas offcanvas-right p-5"
    [ngStyle]="{ overflow: 'hidden' }"
  >
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
      <h3 class="font-weight-bold m-0">User Profile</h3>
      <a class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_user_close">
        <i class="ki ki-close icon-xs text-muted"></i>
      </a>
    </div>
    <div class="offcanvas-content" [ngStyle]="{ height: '100vh', overflow: 'hidden' }">
      <div
        [perfectScrollbar]="{ wheelPropagation: false }"
        class="scroll"
        [ngStyle]="{ height: '600px', position: 'relative' }"
      >
        <div style="display: flex; flex-direction: column">
          <div class="d-flex align-items-center mt-5">
            <div class="mr-5" *ngIf="_user.userName !== 'super_admin'">
              <kt-user-photo
                [create]="false"
                [size]="120"
                [type]="'observable'"
                [editable]="false"
                [user$]="user$"
              ></kt-user-photo>
            </div>
            <div class="d-flex flex-column">
              <a class="font-weight-bold font-size-h5 text-dark-75"
                >{{ _user.lastName }} {{ _user.firstName }}</a
              >
              <div class="text-muted mt-1">{{ _user.companyName }}</div>
              <div class="navi mt-2">
                <a class="navi-item">
                  <span class="navi-link p-0 pb-2">
                    <span class="navi-icon mr-1">
                      <span class="svg-icon svg-icon-lg svg-icon-primary">
                        <span
                          inlineSVG="./assets/media/svg/icons/Communication/Mail-notification.svg"
                        ></span>
                      </span>
                    </span>
                    <span class="navi-text text-muted">{{ _user.email }}</span>
                  </span>
                </a>
                <a
                  (click)="logout()"
                  class="btn btn-sm btn-light-primary font-weight-bolder py-2 px-5"
                  >Sign Out</a
                >
              </div>
            </div>
          </div>
          <div class="separator separator-dashed mt-8 mb-5"></div>
          <div *ngIf="_user.id !== 1" class="navi navi-spacer-x-0 p-0">
            <a (click)="redirectToUserDetails(_user.id)" class="navi-item pointer">
              <div class="navi-link">
                <div class="symbol symbol-40 bg-light mr-3">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-md svg-icon-success">
                      <span inlineSVG="./assets/media/svg/icons/General/profile-new.svg"></span>
                    </span>
                  </div>
                </div>
                <div class="navi-text">
                  <div class="font-weight-bold">My Profile</div>
                  <div class="text-muted">Account settings and more</div>
                </div>
              </div>
            </a>
            <a (click)="openMangeNotificationDialog()" class="navi-item pointer">
              <div class="navi-link">
                <div class="symbol symbol-40 bg-light mr-3">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <span inlineSVG="./assets/media/svg/icons/General/settings-new.svg"></span>
                    </span>
                  </div>
                </div>
                <div class="navi-text">
                  <div class="font-weight-bold">Chat Notification Settings</div>
                  <div class="text-muted">Manage your chat notifications</div>
                </div>
              </div>
            </a>
            <a (click)="openNotification()" class="navi-item pointer">
              <div class="navi-link">
                <div class="symbol symbol-40 bg-light mr-3">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-md svg-icon-secondary">
                      <span
                        inlineSVG="./assets/media/svg/icons/General/notification-new.svg"
                      ></span>
                    </span>
                  </div>
                </div>
                <div class="navi-text">
                  <div class="font-weight-bold">My Notifications</div>
                  <div class="text-muted">Account notifications and more</div>
                </div>
              </div>
            </a>
            <ng-template ngxPermissionsOnly="canImpersonate">
              <a class="navi-item pointer" (click)="openImpersonationDialog()">
                <div class="navi-link">
                  <div class="symbol symbol-40 bg-light mr-3">
                    <div class="symbol-label">
                      <span class="svg-icon svg-icon-md svg-icon-secondary">
                        <span
                          inlineSVG="./assets/media/svg/icons/General/impersonation_icon.svg"
                        ></span>
                      </span>
                    </div>
                  </div>
                  <div class="navi-text">
                    <div class="font-weight-bold">Impersonation</div>
                    <div class="text-muted">View content of a different user</div>
                  </div>
                </div>
              </a>
            </ng-template>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <!-- end::Offcanvas Toolbar Quick User Actions -->
</ng-container>
